/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiLinkStyle = (): Components<Theme>["MuiLink"] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      fontWeight: 500,
      textDecoration: "underline",
      textDecorationThickness: "2px",
      textUnderlineOffset: "5px",
      color: theme.palette.primary.main,
      "&:hover, &:focus-visible": {
        color: theme.palette.primary.dark,
      },
      "&:visited:not(:hover):not(:focus-visible)": {
        color: theme.palette.text.secondary,
      },
      "& .MuiSvgIcon-root": {
        fontSize: "inherit",
        transform: "scale(1.25)",
        paddingBottom: "0.125rem",
        verticalAlign: "middle",
      },
    }),
  },
});
